import React, { useEffect, useState } from "react";
import "../../assets/styles/AllProductUpdateStyle/AllProductUpdate.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { ResetToInit } from "../../action/index";
import { useSelector, useDispatch } from "react-redux";
import { ProductInfoForEdit } from "../../action/index";
import { Navigate } from "react-router-dom";
import { ShowAlert, ProductError } from "../../action/index";
import axios from "../../js/Axios/Axios";
import TopBar from "../../components/TopBar/TopBar";
import ShowInStore from "../../components/ShowProductInStore/ShowProductInStore";
import ProductIntroDuction from "../../components/IntroductionProduction/IntroductionProduction";
import ProductGallery from "../../components/ProductGallery/UploadImage";
import AddProperty from "../../components/AddProperty/AddProperty";
import ProductPrice from "../../components/SimpleProduct/SimpleProduct";
import AddTag from "../../components/AddTag/AddTag";
import CategoryProduct from "../../components/CategoryProduct/CategoryProduct";
import CheckProduct from "../../components/CheckProduct/checkProduct";
import AddSeo from "../../components/AddSeo/Seo";
import UploadIcon from "../../assets/icons/Upload.svg";
import BookMark from "../../assets/icons/Bookmark.svg";
import useForceUpdate from "use-force-update";
import { useLocation } from "react-router-dom";
export default function AllProductUpdate() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const [allData, setAllData] = useState({});
  const Product_info = useSelector((state) => state.ProductInfo);
  const Categorys_id = useSelector((state) => state.SendCategoryId);
  const productProperty = useSelector((state) => state.SendPropertyValueId);
  const productReview = useSelector((state) => state.SendProductReview);
  const Tag_id = useSelector((state) => state.TagId);
  const seoInfo = useSelector((state) => state.SendSeoInfo);
  const seoQuestionAnswer = useSelector((state) => state.SendSeoQuestionAnswer);
  const productgalleryinfo = useSelector(
      (state) => state.SendProductGalleryInfo
  );
  const simpleProductPrice = useSelector(
      (state) => state.SendSimpleProductPrice
  );
  const variableProductPrice = useSelector(
      (state) => state.SendVariableProductPrice
  );

  const id = useSelector((state) => state.UpdateAllProductIds);

  // Get page query parameter from URL
  const searchParams = new URLSearchParams(location.search);
  const pageParam = searchParams.get('page');

  useEffect(() => {
    if (id?.inistateProductid) {
      axios
          .get(`/product/${id.inistateProductid}/edit`)
          .then((res) => {
            if (res.data.status) {
              setAllData(res.data.data);
              dispatch(ProductInfoForEdit(res.data.data));
            }
          })
          .catch((e) => {
            console.log(e);
          });
    }
  }, [id?.inistateProductid]);

  // todo here
  const shareProdcut = async (temp_status) => {
    const simplePrice = simpleProductPrice.simpleProductPrice[0];
    const isCallForPrice = simplePrice?.available_type === "تماس برای قیمت";
    const hasSimplePrice = isCallForPrice || simplePrice?.price != null;

    if (
        (hasSimplePrice &&
            simplePrice.height != null &&
            simplePrice.length != null &&
            simplePrice.width != null &&
            simplePrice.weight) ||
        variableProductPrice.variableProductPrice.length != 0
    ) {
      try {
        const productRes = await axios.put(`/product/${id.inistateProductid}`, {
          title: Product_info.Product_info.title,
          latin_title: Product_info.Product_info.latin_title,
          url: Product_info.Product_info.url,
          country: Product_info.Product_info.country,
          brand_name: Product_info.Product_info.brand_name,
          barcode: Product_info.Product_info.barcode,
          product_introduction: Product_info.Product_info.product_introduction,
          productTags: Tag_id.Tag_id,
          temp_status: temp_status,
          productCategories: Categorys_id.categorysId,
        });

        if (productRes.data.status) {
          dispatch(ShowAlert(true, productRes.data.message));

          const promises = [];

          // Product Gallery
          if (productgalleryinfo.productGalleries.length !== 0) {
            productgalleryinfo.productGalleries.forEach((item) => {
              item.product_id = id.inistateProductid;
            });
            productgalleryinfo.editProduct_id = id.inistateProductid;
            promises.push(axios.post("/productGallery", productgalleryinfo));
          }

          // Product Property
          productProperty.productProperties.forEach((item) => {
            item.product_id = id.inistateProductid;
          });
          productProperty.isProductEdit = 1;
          productProperty.product_id = id.inistateProductid;
          promises.push(axios.post("/productProperty", productProperty));

          // Product Review
          productReview.forEach((item) => {
            item.product_id = id.inistateProductid;
          });
          const validReviews = productReview.filter(
              (item) =>
                  item.description && item.media_id && item.product_id && item.title
          );
          if (validReviews.length > 0) {
            promises.push(axios.post("/productReview", validReviews));
          }

          // SEO Info
          if (
              seoInfo.seo_info.canonical &&
              seoInfo.seo_info.meta &&
              seoInfo.seo_info.title &&
              seoInfo.seo_info.url
          ) {
            const product_id = { product_id: id.inistateProductid };
            const finalSeo = Object.assign(seoInfo.seo_info, product_id);

            if (seoInfo.seo_info.seoId != null) {
              const seoRes = await axios.put(
                  `/productSeo/${seoInfo.seo_info.seoId}`,
                  finalSeo
              );
              if (seoRes.data.status) {
                seoQuestionAnswer.productSeo_id = seoRes.data.data.id;
                seoQuestionAnswer.is_edit = 1;
              }
            } else {
              const seoRes = await axios.post("/productSeo", finalSeo);
              if (seoRes.data.status) {
                seoQuestionAnswer.productSeo_id = seoRes.data.data.id;
                seoQuestionAnswer.is_edit = 0;
              }
            }

            const faqs = seoQuestionAnswer.faqs.filter(
                (item) => item.question && item.answer
            );
            if (faqs.length > 0) {
              promises.push(
                  axios.post("/productSeoFaq", {
                    productSeo_id: seoQuestionAnswer.productSeo_id,
                    is_edit: seoQuestionAnswer.is_edit,
                    faqs,
                  })
              );
            }
          }

          // Product Price
          if (variableProductPrice.variableProductPrice.length > 0) {
            if (allData.productPrices.length > 0) {
              allData.productPrices.forEach((item) => {
                variableProductPrice.variableProductPrice.forEach((product) => {
                  if (item.main_value == product.main_value) {
                    product.editPrice_id = item.id;
                  } else {
                    product.product_id = allData.id;
                  }
                });
              });
            }
            promises.push(
                axios.post(
                    "/productPrice",
                    variableProductPrice.variableProductPrice
                )
            );
          } else {
            if (allData.productPrices.length > 0) {
              simpleProductPrice.simpleProductPrice[0].editPrice_id =
                  allData.productPrices[0].id;
              simpleProductPrice.simpleProductPrice[0].product_id = allData.id;
              promises.push(
                  axios.post(
                      "/productPrice",
                      simpleProductPrice.simpleProductPrice
                  )
              );
            }
          }

          // Wait for all axios calls to complete
          await Promise.all(promises);

          dispatch(ResetToInit());
          navigate(pageParam ? `/AllProduct?page=${pageParam}` : "/AllProduct");
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      dispatch(
          ProductError({
            price: true,
            weight: true,
            height: true,
            length: true,
            width: true,
          })
      );
      dispatch(
          ShowAlert(true, ["برای انتشار محصول فیلد قیمت و ابعاد الزامی است"])
      );
    }
  };

  return (
      <div className="AllProductUpdateAll">
        <TopBar />
        <div className="AllProductUpdateTopButtonBox">
          <button
              onClick={() => shareProdcut(1)}
              className="AllProductUpdateTopButtonShareProduct"
          >
            <img src={UploadIcon} />
            <p className="AllProductUpdateTopButtonShareProductTittle">
              محصول منتشر شود
            </p>
          </button>
          <button
              onClick={() => shareProdcut(0)}
              className="AllProductUpdateTopButtonSaveProductTittle"
          >
            <img src={BookMark} />
            <p className="AllProductUpdateTopButtonShareProductTittle">
              ذخیره در پیش‌نویس ها
            </p>
          </button>
        </div>

        {/* Preview */}
        <div className="AllProductUpdateStore">
          {id.inistateProductid === "" && <Navigate to={pageParam ? `/AllProduct?page=${pageParam}` : "/AllProduct"} />}
          <ShowInStore data={allData} />
        </div>

        {/* Forms */}
        <div className="AllProductUpdateComponentBox">
          <ProductIntroDuction />
          <ProductGallery />
          <div className="AllProductUpdatePriceandPropertyBox">
            <div className="AllProductUpdatePriceBox">
              <ProductPrice />
            </div>
            <div className="AllProductUpdatePropertyBox">
              <AddProperty />
            </div>
          </div>
          <div className="AllProductUpdateAddTagandAddCategory">
            <div className="AllProductUpdateAddTagBox">
              <AddTag />
            </div>
            <div className="AllProductUpdateAddCategoryBox">
              <CategoryProduct />
            </div>
          </div>
          <div className="AllProductUpdateProductReview">
            <CheckProduct />
          </div>
          <div className="AllProductUpdateAddSeo">
            <AddSeo />
          </div>
        </div>
      </div>
  );
}
